/* 🤖 this file was generated by svg-to-ts */
export const matIconPregnantWoman: {
  name: 'pregnant-woman';
  data: string;
} = {
  name: 'pregnant-woman',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 0 0-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"/></svg>`
};
